export default __webpack_public_path__ + "static/media/mbwayApp.a7c3410e.png";